import styled from "styled-components";

export const Container = styled.footer`
    width: 100%; 
    padding: 25px 0px 25px 0px;
    background: #363c42;
    //margin-top: 30rem;
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 640px) {
        flex-direction: row;
    }
`;

export const Epharma = styled.div`
    height: 100%;
    margin-top: 50px;

    img {
        margin-left: 0.5rem;
        width: 150px;
    }
`;

export const Contact = styled.div`
    margin-left: 12px;

    p {
        color: #fff;
        font-size: 12px;
        line-height: 17px;
        letter-spacing: 1px;
    }
`;

export const Canais = styled.div`
    color: #fff;
    letter-spacing: 1px;
    text-align: center;

    .atendimento {
        display: flex;
        flex-direction: row;

        div {
            margin: 0px 20px;
        }

        img {
            width: 65px;
        }
    }
    
    h3 {
        font-size: 18px;
        margin: 0px 0px 25px 0px;
    }
    h4 {
        font-size: 18px;
        margin: 20px 0px 5px 0px;
    }

    p {
        font-size: 11px;
    }

    a {
        color: #ffffff;
        font-size: 11px
    }
`;